module.exports = __webpack_public_path__ + "files/3b6e750e05bd74ae887c3bbef695eb33.png";